import { Routes } from '@angular/router';
import { RenewalComponent } from './renewal.component';


export const renewalRoutes: Routes = [
    { path: 'renewal/list', component: RenewalComponent },
  ];

export const renewlRoutingComponents = [RenewalComponent];
